import BiRewardButton from './BiRewardButton.f';

export default BiRewardButton;
